import { type WallProvider } from "@package/ui-wall-engine";
import { createContext, useContext } from "react";

export const WallContext = createContext<WallProvider | undefined>(undefined);
export const useWallProvider = () => useContext(WallContext);
